exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label {\r\n\tfont-size: 14px;\r\n}\r\n\r\n.inputs-form {\r\n\tbackground-color: #e5e0e0;\r\n\tpadding: 10px;\r\n\toutline: none;\r\n\t-ms-flex: auto;\r\n\t    flex: auto;\r\n\tborder: none;\r\n\tbox-shadow: 0px 2px 5px rgba(0,0,0,0.3);\t\r\n\ttext-align: right;\r\n}\r\n\r\n.disabled-buttons {\r\n\tbackground-color: #e5e0e0 !important;\r\n}\r\n\r\ninput[type=\"text\"] {\t\r\n\theight: 18px !important;\r\n}\r\n\r\nselect {\r\n\twidth: 100%;\r\n\tmin-height: 38px;\r\n} \r\n\r\n.fab-button-style {\r\n\tmargin-top: -27px;\r\n\tmargin-left: 0%;\r\n\tposition: absolute;\r\n\tz-index: 9999;\r\n}\r\n\r\n::ng-deep .mat-tab-header {\r\n\tbackground-color: white !important;\r\n}\r\n\r\n::ng-deep .mat-tab-label {\r\n\tcolor: #069169 !important;\r\n}\r\n\r\n::ng-deep .mat-ink-bar {\r\n\tbackground-color: #069169 !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/github/490/rec_ng_recibopago490v7/src/app/components/pago/pago.component.css
// module id = ../../../../../src/app/components/pago/pago.component.css
// module chunks = main